<template>
    <div class="modal fade" id="cvModal" tabindex="-1" aria-labelledby="cvModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="text-uppercase">déposer votre CV</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        @click="$emit('close-modal')"></button>
                </div>
                <div class="modal-body">
                    <div class="loader" v-if="loading"></div>
                    <div class="row mb-3">
                        <div class="col-md-9 title mb-3">
                            <p class="text-start">Nous vous contacterons lorsqu'un poste en adéquation avec votre profil
                                sera à
                                pourvoir.
                            </p>
                        </div>
                        <div class="col-md-3">
                            <a href="tel:0562471909">
                                <span class="tel-form">
                                    <i class="fa-solid fa-phone"></i>&nbsp; 05 62 47 19 09
                                </span>
                            </a>
                        </div>
                    </div>
                    <h4 class="mb-40 fw-semibold" v-if="jobTitle">{{ jobTitle }}</h4>
                    <div class="col-md-12 box-success mb-40" v-if="msgResponseSuccess">
                        <p class="text-start">Votre email a bien été envoyé !</p>
                    </div>
                    <div class="col-md-12 box-error mb-40" v-if="msgResponseError">
                        <p class="text-start"> {{ errorForm }} </p>
                    </div>
                    <form ref="form" @submit.prevent="submitForm">
                        <div class="row mb-3">
                            <div class="col-md-6 mb-3">
                                <input type="text" class="form-control" placeholder="Nom*" required
                                    v-model="formData.nom">
                            </div>
                            <div class="col-md-6 mb-3">
                                <input type="text" class="form-control" placeholder="Prénom*" required
                                    v-model="formData.prenom">
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-6 mb-3">
                                <input type="email" class="form-control" placeholder="E-mail*" required
                                    v-model="formData.email">
                            </div>
                            <div class="col-md-6 mb-3">
                                <input type="tel" class="form-control" placeholder="Téléphone*" required
                                    v-model="formData.telephone">
                            </div>
                        </div>
                        <div class="row mb-3 justify-content-center">
                            <div class="col-md-6 mb-3 file-input-left">
                                <label for="cv" class="form-label text-start">CV*</label>
                                <input type="file" class="form-control" accept-language="fr" id="cv"
                                    accept=".docx,.rtf,.pdf" @change="handleFileUpload($event, 'cv')" required>
                            </div>
                            <div class="col-md-6 mb-3 file-input-right">
                                <label for="lettreMotivation" class="form-label">Lettre de motivation</label>
                                <input type="file" class="form-control" accept-language="fr" id="lettreMotivation"
                                    accept=".docx,.rtf,.pdf" @change="handleFileUpload($event, 'lm')">
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-12">
                                <textarea class="form-control" placeholder="Message..."
                                    v-model="formData.message"></textarea>
                            </div>
                        </div>
                        <div class="d-flex flex-row">
                            <div id="divRecaptcha">
                                <div id="recaptcha" class="g-recaptcha"
                                    data-sitekey="6LecGm0pAAAAAMyqbcdwfTP_bhETHtarE0vlrX3l">
                                </div>
                            </div>
                            <div class="errors" v-if="errorsFormContact.includes('captcha')">Veuillez valider le
                                captcha !</div>
                            <div class="errors" v-if="errorsFormContact.includes('captchaVerification')">Erreur
                                de vérification du ReCaptcha, veuillez réessayer plus tard ou contactez le
                                support SVP !
                            </div>
                            <button class="nav-link contact" type="submit">
                                <span>Déposer mon CV
                                    <i class="fa-solid fa-arrow-right"></i>
                                </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    jobTitle: String
});



const errorsFormContact = ref([])
const msgResponseSuccess = ref(false);
const msgResponseError = ref(false);
const errorForm = ref("Erreur, merci de contacter admin@emciconseil.fr");

const form = ref(null);
let fileName = [];
const url = useRequestURL()

const formData = ({});

const loading = ref(false);

let scriptTag;

onMounted(() => {
    // Recaptcha
    setTimeout(() => {
        var divRecaptcha = document.getElementById("divRecaptcha")
        document.getElementById("recaptcha").remove();
        divRecaptcha.innerHTML = `<div id="recaptcha" class="g-recaptcha" data-sitekey="6LecGm0pAAAAAMyqbcdwfTP_bhETHtarE0vlrX3l"></div>`;
        scriptTag = document.createElement("script");
        scriptTag.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        scriptTag.setAttribute("defer", "");
        scriptTag.setAttribute("async", "");
        document.body.appendChild(scriptTag);
    }, 1000)
})

onUnmounted(() => {
    if (scriptTag) {
        scriptTag.remove();
    }
})

const handleFileUpload = async (event, fieldName) => {
    switch (fieldName) {
        case 'cv':
            formData.fileCv = event.target.files[0];
            break;
        case 'lm':
            formData.fileLm = event.target.files[0];
            break;

        default:
            break;
    }
};


const submitForm = async () => {
    formData.job = props.jobTitle ? "CANDIDATURE-EMCI-[" + props.jobTitle + "]" : "CANDIDATURE";
    loading.value = true;
    errorsFormContact.value = []

    if (!form.value.checkValidity()) {
        form.value.reportValidity();
        msgResponseError.value = true;
        errorForm.value = "Validation incorrecte, merci de recharger la page et de remplir correctement les champs";
        setTimeout(() => {
            msgResponseError.value = false;
        }, 6000);
        loading.value = false;
        return;
    }
    if (!grecaptcha.getResponse()) {
        errorsFormContact.value.push("captcha");
        msgResponseError.value = true;
        errorForm.value = "Validation recaptcha non disponible, merci de vérifier votre internet et de réactualiser la page";
        setTimeout(() => {
            msgResponseError.value = false;
        }, 6000);
        loading.value = false;
    } else {
        const token = grecaptcha.getResponse();
        const responseCaptcha = await $fetch('/api/verifyCaptcha', {
            method: 'POST',
            body: { response: token },
        });
        if (responseCaptcha.success === true && errorsFormContact.value.length === 0) {
            const cvFile = await saveFile(formData.fileCv);
            const lmFile = await saveFile(formData.fileLm);

            const msgBody = ref("");

            msgBody.value = `
                Sujet : CANDIDATURE-${formData.prenom}-${formData.nom}<br/><br/>
                [EMCI] Vous avez un message depuis votre site web de la part de :<br /><br />
                ${formData.prenom} ${formData.nom} <br/>
                Email : ${formData.email} <br/>
                Téléphone: ${formData.telephone} <br/>
                <br />
                Message :<br/>
                ${formData.message} <br /><br />
                Voici le lien pour ses pièces jointes : <br/>
                <br />Curriculum vitae : <br /><a href="//${url.host}/fichiers/${cvFile.fileName}" target="_blank"><b><i><u>${cvFile.fileName}</u></i/></b> </a> <br />ou copier sur l'url de votre navigateur son CV : <b><i>//${url.host}/fichiers/${cvFile.fileName}</i></b><br/>
                ${lmFile.fileName ? `<br />Lettre de motivation : <br /><a href="//${url.host}/fichiers/${lmFile.fileName}" target="_blank"><b><i><u>${lmFile.fileName}</u></i/></b> </a> <br />ou copier sur l'url de votre navigateur sa LM : <b><i>//${url.host}/fichiers/${lmFile.fileName}</i></b><br/>` : ''}
                `;

            const submissionData = {
                pKey: 'EmPA5d6sdse5z6ldfjPAEhazozp5ksJEZkzn872', //GBBU EMCI : EmPA5d6sdse5z6ldfjPAEhazozp5ksJEZkzn872 - GBBU TEST VrPndaEzxehPS7f63ZEr8vVdK2HtGDfD
                pType: "web-contact",
                pFct: 'SetContact',
                pMsgLastname: formData.nom,
                pMsgFirstname: formData.prenom,
                pMsgEmail: formData.email,
                pMsgPhone: formData.telephone,
                pMsgSubject: formData.job,
                pMsgMessage: msgBody.value
            };
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(submissionData),
            });
            if (response.status === 200) {
                loading.value = false;
                msgResponseSuccess.value = true;
                setTimeout(() => {
                    msgResponseSuccess.value = false;
                }, 3000);
                // Remettre les données à vide ou null ici
                formData.nom = '';
                formData.prenom = '';
                formData.email = '';
                formData.telephone = '';
                formData.message = '';
                formData.fileCv = null;
                formData.fileLm = null;
            }

        } else {
            errorsFormContact.value.push("captchaVerification");
            msgResponseError.value = true;
            errorForm.value = "Une erreur s'est produite durant votre requête, merci de rafraichir la page avant de réessayer";
            setTimeout(() => {
                msgResponseError.value = false;
            }, 6000);
            loading.value = false;
        }
    }
};

const saveFile = (file) => {
    const formDataFile = new FormData();
    formDataFile.append('file', file);
    const uploadfile = $fetch('/api/uploadfile', {
        method: 'POST',
        body: formDataFile,
    });
    return uploadfile;
}
</script>

<style scoped>
.black-text {
    color: #25233E;
}

.i-do-check {
    font-weight: normal;
    color: #25233E;
}

.i-do-check:hover {
    font-weight: 300;
    color: #25233E !important;
}

.file-input-left,
.file-input-right {
    text-align: left;
    border-radius: 5px;
    padding: 1rem;
}




.tel-form {
    width: 24%;
    margin-left: 10px;
    border-radius: 2em !important;
    background: #FFFF;
    border: 2px solid var(--tertiaire, #318EC7);
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
    letter-spacing: 0.68px;
    white-space: nowrap;
    color: var(--accent, #25233E);
}

.tel-form:hover {
    background: var(--primaire, #318EC7);
    border: none;
    color: var(--primaire, #FFF);
}

.errors {
    position: absolute;
    top: 100%;
    color: #ff4949;
    background: #FFFF;
    padding: 5px;
    font-size: 23px;
}

/* Select custom */
select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    outline: 0;
    flex: 1;
    padding: 0 .5em;
    color: #25233E ! important;
    cursor: pointer;
    font-size: 1em;
    font-family: 'Inter';
}

option {
    color: #25233E
}


/*  */


.form-control:hover,
.form-check-input:hover {
    border-color: #318EC7;
    /* Couleur de la bordure au survol */
}

.form-check-label:hover {
    color: #318EC7;
    /* Couleur du texte au survol */
}

p,
.text-i-do {
    color: var(--accent, #25233E);
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 144%;
    letter-spacing: 0.72px;
    text-align: justify;
}




.modal-content {
    padding: 8px 60px 60px 60px !important;
    background: #e3f0f6 !important;
}

.modal-header {
    border-bottom: unset;
}

#cv,
#lettreMotivation {
    border: none;
}

.btn-close {
    border-radius: 50%;
    width: 35px;
    height: 35px;
    margin-right: -55px;
    margin-top: -20px;
}

.btn-close:hover {
    background-color: #FFFF;
}

.contact {
    height: 50px;
    width: 230px;
    margin-top: 15px;
    margin-left: 15px;
}

p {
    font-size: 15px;
}

.loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border: 10px solid #f3f3f3;
    /* Light grey */
    border-top: 16px solid #3498db;
    /* Blue */
    border-radius: 50%;
    width: 75px;
    height: 75px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@media screen and (min-width: 300px) and (max-width: 768px) {
    .modal-content {
        padding: 8px 10px 60px 10px !important;
    }

    .rc-anchor-normal {
        width: 286px;
    }

    .btn-close {
        margin-right: -15px;
    }
}

@media screen and (min-width: 1200px) {}
</style>